module.exports = __webpack_public_path__ + "img/IMG-20180727-WA0032.68725a62.jpg";